import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import DealerLocation from './DealerLocation';
import messages from '../../../utils/translationMessages';

const LocatorBody = ({ helper, device, pageIndex, setDealerIndex, intl }) => {
  const { formatMessage: t } = intl;

  const PreviousBtn = () => (
    <button
      className="previous-btn"
      disabled={!helper.hasPreviousPage()}
      onClick={() => helper.previousPage()}
    >
      {t(messages.dealerLocatorModal.pagePrevious)}
    </button>
  );

  const NextBtn = () => (
    <button
      className="next-btn"
      disabled={!helper.hasNextPage()}
      onClick={() => helper.nextPage()}
    >
      {t(messages.dealerLocatorModal.pageNext)}
    </button>
  );

  return (
    <div id="locator-body">
      <h4>{t(messages.dealerLocatorModal.dealersFound, { totalListings: helper.totalListings() })}</h4>
      <ol>
        {helper.dealers(device)?.map((dealer, key) => (
          <li
            key={key}
            data-reporting-event-category="soft lead"
            data-reporting-event-action="view dealer"
            data-reporting-event-label={get(helper, 'partyId')}
          >
            <DealerLocation
              dealerIndex={helper.getStartIndex() + key}
              dealerKey={helper.getStartIndex() + key}
              setDealerIndex={setDealerIndex}
              dealer={dealer}
            />
          </li>
        ))}
      </ol>
      {device === 'desktop' && (
        <footer>
          <PreviousBtn />
          <div className="pagination-container">
            {helper.pagination()?.map((term, key) =>
              term && Number.isInteger(term) ? (
                <button
                  disabled={
                    term - 1 === pageIndex || term > helper.getLastPage()
                  }
                  key={key}
                  className="pagination-button"
                  onClick={() => helper.goToPageIndex(term - 1)}
                >
                  {term}
                </button>
              ) : (
                <span key={key}>{term}</span>
              )
            )}
          </div>
          <NextBtn />
        </footer>
      )}
    </div>
  );
};

LocatorBody.propTypes = {
  helper: PropTypes.any.isRequired,
  device: PropTypes.string.isRequired,
  pageIndex: PropTypes.number.isRequired,
  setDealerIndex: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(LocatorBody);
